import React from "react";
import slide1 from "../../assets/slide-1.jpg";
import slide2 from "../../assets/slide-2.jpg";
import slide3 from "../../assets/slide-3.jpg";
import slide4 from "../../assets/slide-4.jpg";
import slide5 from "../../assets/slide-5.jpg";
import leftArrow from "../../assets/left-arrow.svg";
import rightArrow from "../../assets/right-arrow.svg";
import "./slider.css";

const Slider = () => {
  return (
    <div className="home">
      <div
        data-bs-interval="3500"
        id="carousel"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-controls">
          <ol className="carousel-indicators">
            <li
              data-bs-target="#carousel"
              data-bs-slide-to={0}
              className="active"
              style={{ backgroundImage: `url(${slide1})` }}
            />
            <li
              data-bs-target="#carousel"
              data-bs-slide-to={1}
              style={{ backgroundImage: `url(${slide5})` }}
            />
            <li
              data-bs-target="#carousel"
              data-bs-slide-to={2}
              style={{ backgroundImage: `url(${slide2})` }}
            />
            <li
              data-bs-target="#carousel"
              data-bs-slide-to={3}
              style={{ backgroundImage: `url(${slide3})` }}
            />
            <li
              data-bs-target="#carousel"
              data-bs-slide-to={4}
              style={{ backgroundImage: `url(${slide4})` }}
            />
          </ol>
          <a
            className="carousel-control-prev"
            href="#carousel"
            role="button"
            data-bs-slide="prev"
          >
            <img src={leftArrow} alt="Prev" />
          </a>
          <a
            className="carousel-control-next"
            href="#carousel"
            role="button"
            data-bs-slide="next"
          >
            <img src={rightArrow} alt="Next" />
          </a>
        </div>
        <div className="carousel-inner">
          <div
            className="item-1 carousel-item active"
            style={{ backgroundImage: `url(${slide1})` }}
          >
            <div className="container">
              <h2>This summer!</h2>
              <p>You can find the most trending products here</p>
            </div>
          </div>
          <div
            className="carousel-item item-5"
            style={{ backgroundImage: `url(${slide5})` }}
          >
            <div className="container">
              <h2>Very soon!</h2>
              <p>We are opening a new store in Istanbul!</p>
            </div>
          </div>
          <div
            className="carousel-item"
            style={{ backgroundImage: `url(${slide2})` }}
          >
            <div className="container">
              <h2>Collar T-Shirts</h2>
              <p>$69.90</p>
            </div>
          </div>
          <div
            className="item-3 carousel-item"
            style={{ backgroundImage: `url(${slide3})` }}
          >
            <div className="container">
              <h2 className="display-6">Elite Striped Shirt</h2>
              <p>$97.50</p>
            </div>
          </div>
          <div
            className="item-6 carousel-item"
            style={{ backgroundImage: `url(${slide4})` }}
          >
            <div className="container">
              <h2>Free Delivery!</h2>
              <p>$100 or more shopping, shipping fee is on us!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
